import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledUiStepper = styled('div')(
  () => css`
    @media screen and (max-width: 900px) {
      .MuiStepper-root {
      }
    }

    @media screen and (max-width: 576px) {
      .MuiStepper-root.is-first-step-active {
        .MuiStep-horizontal,
        .MuiStepConnector-horizontal {
          display: none;
        }
        .MuiStep-horizontal:nth-child(1),
        .MuiStepConnector-horizontal:nth-child(2),
        .MuiStep-horizontal:nth-child(3),
        .MuiStepConnector-horizontal:nth-child(4),
        .MuiStepConnector-horizontal:nth-child(6),
        .MuiStep-horizontal:nth-last-child(1),
        .MuiStepConnector-horizontal:nth-last-child(2) {
          display: block;
        }
        .MuiStepConnector-horizontal:nth-child(6) {
          span {
            border-top-style: dashed;
          }
        }
        .MuiStepConnector-horizontal:nth-last-child(2) {
          span {
            border-top-style: line;
          }
        }
      }
      .MuiStepper-root.is-middle-steps-active {
        .MuiStep-horizontal:not(:first-of-type) {
          span {
            display: none;
          }
        }
        .MuiStep-horizontal .active span {
          display: block !important;
        }
        .active-connector:not(:last-of-type) {
          span {
            display: none !important;
          }
        }
      }
      .MuiStepper-root {
        div:has(> div.active) {
          display: block !important;
        }
      }
    }
  `
);
